module.exports = __webpack_public_path__ + "assets/img/E.9c891ad4.jpg";